import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { SearchTextBox } from './searchTextBox';
import { AddButton } from '../buttons/addButton';
export const SearchBar = t0 => {
  const $ = _c(22);
  const {
    value,
    setValue,
    placeholder,
    selectedValues,
    onAddClick,
    showAddButton,
    hideSearchIcon
  } = t0;
  let t1;
  if ($[0] !== onAddClick || $[1] !== selectedValues || $[2] !== setValue || $[3] !== showAddButton || $[4] !== value) {
    t1 = () => {
      if (showAddButton && onAddClick) {
        const values = [...selectedValues, value];
        onAddClick(values);
        setValue("");
      }
    };
    $[0] = onAddClick;
    $[1] = selectedValues;
    $[2] = setValue;
    $[3] = showAddButton;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const addCallback = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexGrow: 1
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = showAddButton && onAddClick ? addCallback : undefined;
  let t4;
  if ($[7] !== hideSearchIcon || $[8] !== placeholder || $[9] !== setValue || $[10] !== t3 || $[11] !== value) {
    t4 = <SearchTextBox value={value} onChange={setValue} placeholder={placeholder} sx={t2} hideIcon={hideSearchIcon} onEnter={t3} />;
    $[7] = hideSearchIcon;
    $[8] = placeholder;
    $[9] = setValue;
    $[10] = t3;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== addCallback || $[14] !== onAddClick || $[15] !== selectedValues || $[16] !== showAddButton || $[17] !== value) {
    t5 = showAddButton && onAddClick && <AddButton disabled={selectedValues.includes(value) || !value} onClick={addCallback} />;
    $[13] = addCallback;
    $[14] = onAddClick;
    $[15] = selectedValues;
    $[16] = showAddButton;
    $[17] = value;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <Stack direction="row" alignItems="center" paddingY="12px" gap="12px" className="w-full">{t4}{t5}</Stack>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};